export const COPY = {
  pageDescription: 'Delivery log for vendor email. Paste a PO number.',
  emptyTitle: 'Nothing to inspect.',
  emptyDetail: 'Herald has not accepted a message yet.',
  filteredTitle: 'No matches.',
  filteredDetail: 'Nothing lines up with the current filters.',
  clearFilters: 'Clear filters',
  loadError: 'Messages failed to load.',
  retry: 'Retry',
  stale: 'Last refresh failed — showing the previous page.',
  loading: 'Loading messages…',
  toastMessageId: 'Copied MessageId.',
  poPdf: 'Released PDF',
  poPdfChip: 'Released purchase order.',
  dryRunBanner: 'Shadow — dryRun=true. SES was not called.',
  dryRunShort: 'Shadow — Herald did not call SES.',
  duplicateBanner: 'Replay of this message. SES was not called again.',
  delayedBanner: (n: number) =>
    `SES accepted this ${n} minutes ago. No delivery or bounce yet.`,
  waDelayedBanner: (n: number) =>
    `WhatsApp accepted this ${n} minutes ago. No delivery or read yet.`,
  suppressedBanner: (email: string) =>
    `${email} is on the SES suppression list. SES was not called.`,
  signInLead: 'Outbound email for the company. Sign in with your Boldfit Microsoft account.',
} as const
